import { render, staticRenderFns } from "./SchemaMergePreviewer.vue?vue&type=template&id=67e848c6&scoped=true&"
import script from "./SchemaMergePreviewer.vue?vue&type=script&lang=js&"
export * from "./SchemaMergePreviewer.vue?vue&type=script&lang=js&"
import style0 from "./SchemaMergePreviewer.vue?vue&type=style&index=0&id=67e848c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e848c6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCombobox,VIcon})
